app.directive('includeReplace', () => {
	return {
		require: 'ngInclude',
		restrict: 'A', /* optional */
		link: (scope, el, attrs) => {
			el.replaceWith(el.children());
		}
	};
});
